<template>
  <div class="step-guide">
    <div class="empty-box">
      <h2 class="title">{{ title }}</h2>
      <p class="description">{{ description }}</p>

      <div class="steps">
        <div v-for="(step, index) in steps" :key="index" class="step-item">
          <div class="step-icon">
            <span>{{ index + 1 }}</span>
            <div v-if="index < steps.length - 1" class="step-line"></div>
          </div>
          <div class="step-text">{{ step }}</div>
        </div>
      </div>

      <div class="slot-wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const title = computed(() => {
  return route.params.id === 'products' ? `Get your products onto creator's storefronts` : `Add Collections To Creator Storefronts`;
});

const description = computed(() => {
  return route.params.id === 'products'
    ? `You can place products on all storefronts or designate them to specific creators and groups.`
    : `You can place collections on all storefronts or designate them to specific creators and groups.`;
});

const steps = computed(() => {
  if (route.params.id === 'products') {
    return [
      "Start by selecting a product from the database catalog, or add a URL from your site, or upload a CSV file.",
      "Pick a product and edit the product setting to designate the storefront of the creator/group.",
      "Review all your selected products, make any necessary adjustments, and then publish them to your designated storefront."
    ]
  } else if (route.params.id === 'collections') {
    return [
      "Create a new collection and adjust its settings and appearance.",
      "Select the products that should be displayed within the collection.",
      "Review your selections and click publish."
    ]
  }
});
</script>

<style lang="scss" scoped>
.step-guide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 78px);

  .empty-box {
    max-width: 800px;
    background: #fff;
    padding: 48px;
    border-radius: 16px;
  }
}

.title {
  font: var(--medium-24);
  color: var(--black-100);
  margin-bottom: 4px;
}

.description {
  font-size: 16px;
  color: var(--black-100);
  margin-bottom: 24px;
}

.steps {
  margin-bottom: 32px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  position: relative;
}

.step-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 24px;
  margin-right: 12px;
  justify-content: center;
}

.step-icon span {
  background: var(--black-90);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-line {
  flex-grow: 1;
  width: 2px;
  height: 24px;
  background: var(--black-90);
  margin-top: 8px;
}

.step-text {
  font-size: 16px;
  color: var(--black-100);
  flex: 1;
}

.slot-wrapper {
  display: flex;
  justify-content: flex-end;
}
</style>
